import { CommonModule } from '@angular/common';
import { Component, input, signal } from '@angular/core';
import { CommonUtils, SwitchAction } from '@infodata-group/inf-commons';
import { TouchAction } from '../touch-action';

@Component({
  selector: 'infl-touch-switch-action',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './touch-switch-action.component.html',
  styleUrls: ['./touch-switch-action.component.scss', '../touch-action.scss'],
})
export class TouchSwitchActionComponent extends TouchAction {
  public override action = input.required<SwitchAction<any>>();

  protected black = signal<string>(CommonUtils.color('black'));
}
